/**
 * Created by Christof Sander on 13.10.2016.
 */

const CONSTANTS = require('../../lib/constants');
const utils = require('../../lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		// children of relationships will be rendered via action. therefor a normal build process will never need to build children of such an element.
		// this will prevent multiple builds, resourceSanitize() calls and all errors down the line.
		postponeChildren: true,
		subFormComponent: null,
		defaultSubFormComponent: [
			'/',
			'base',
			'form',
			'form'
		],
		modeDependentContainerComponent: {
			tabStrip: [
				'/',
				'base',
				'tabStrip',
				'tabStrip'
			],
			accordion: [
				'/',
				'base',
				'accordion',
				'accordion'
			]
		},
		separatorMode: 'tabStrip',
		availableSeparators: {
			initialized: false,
			// usually relationship forms include multiple subForms separated by dataIndex, fieldValues or availableLangCodes.
			// in these cases the dirtyFields of changing subForms have to be written to the right location potentially based on an subDataIndex.
			// if the config.availableSeparators.type === 'single' mode is used we aim for one single subForm which should write to a parent's attribute json-field.
			// in this case (and maybe other cases in the future) the automatic usage of subDataIndexes has to be prevented.
			// type: undefined, // availableLangCodes, single, ... // TODO: extend this list
			list: []
		},
		parentFormResourceKey: 'relationships',
		separatorKey: 'langCode',
		// relationContainerConfigExtension: {
		// 	addRelationshipElementButtonFormMapping: false
		// }

		// TODO: DOC OF OTHER FLAGS?!
	},

	model: {
		nrOfRelationshipElements: 0
	},

	methods: {
		/**
		 * this function is used to handle validation errors in relationship forms.
		 *
		 * @param childComponent		Component - subForm which failed on validation
		 * @param validationResult		object - validationResult given by validator
		 * @param firstError			boolean - is this the global first error within the actual mainForm
		 */
		handleRelationshipChildValidationError: function(childComponent, validationResult, firstError){

			// handle validation error separatorMode dependent
			switch (this.config.separatorMode) {
				case 'tabStrip':
					if(childComponent && this.actions.relationContainer && this.actions.relationContainer.source.load.component){
						// estimate tab-registerSecret
						var tabRegisterSecret;
						childComponent.closest('base_tabStrip_tabContent', function(tabContentComponent){
							tabRegisterSecret = tabContentComponent.config.registerSecret;
						});

						if(tabRegisterSecret !== undefined){
							this.actions.relationContainer.source.load.component.markTab(tabRegisterSecret, validationResult.invalid ? 'validationFailed' : '');
							if(validationResult.invalid && firstError){
								this.actions.relationContainer.source.load.component.focusTab(tabRegisterSecret);
							}
						}
					}
					break;

				case 'accordion':
					if(childComponent && this.actions.relationContainer && this.actions.relationContainer.source.load.component){
						let elementRegisterSecret;
						childComponent.closest('base_accordion_element', elementComponent => {
							elementRegisterSecret = elementComponent.config.registerSecret;
						});

						if(elementRegisterSecret !== undefined){
							this.actions.relationContainer.source.load.component.markElement(elementRegisterSecret, 'validationFailed', validationResult.invalid);
							if(validationResult.invalid && firstError){
								this.actions.relationContainer.source.load.component.focusElement(elementRegisterSecret);
							}

						}
					}
					break;

				case 'inline':
					if((this.config.availableSeparators || {}).type === 'single'){
						// forward validation result to next available relationship handler if possible
						this.parentComponents('base_form_form', form => {
							if(typeof form.handleRelationshipChildValidationError === 'function'){
								form.handleRelationshipChildValidationError(childComponent, validationResult, firstError)
								return false;
							}
						})
					}
					break;
			}
		},

		/**
		 * this function returns the resourceDataIndex according to the given separatorKey or void in an error case.
		 *
		 * @param 	separatorKey		mixed - separator key to find
		 * @return 	void | int - resourceDataIndex
		 */
		getRelationshipDataIndex: function(separatorKey){
			var self = this;
			var result;

			// find data according to separator
			if(self.resourceData && self.resourceData.data){
				utils.forEach(self.resourceData.data, function (resource, resourceIndex) {
					if(self.config.availableSeparators.type === 'dataIndex'){
						if(resourceIndex == ((self.config.availableSeparators.list[separatorKey] || {}).key || separatorKey)){
							result = resourceIndex;
							return false;
						}
					}
				 	else if (resource.attributes && resource.attributes[self.config.separatorKey] == ((self.config.availableSeparators.list[separatorKey] || {}).key || separatorKey)) {
						result = resourceIndex;
						return false;
					}
				});
			}

			return result;
		},

		/**
		 * this function adds a relationship element to the dom according to the given parameters.
		 *
		 * @param separatorKey
		 * @param separator
		 * @returns {*}
		 */
		addRelationshipElement: function(separatorKey, separator){
			separator = separator || {};

			const self = this;
			const isSingle = (self.config.availableSeparators || {}).type === 'single';
			let data;
			self.model.nrOfNonIdentifiedRelationshipDataSets = self.model.nrOfNonIdentifiedRelationshipDataSets || 0;
			self.model.nrOfRelationshipElements++;

			// find data according to separator
			if (!isSingle && (separator.resourceIndex = self.getRelationshipDataIndex(separatorKey)) == undefined) {
				separator.resourceIndex = (self.resourceData.data && Array.isArray(self.resourceData.data) ? self.resourceData.data.length : 0) + self.model.nrOfNonIdentifiedRelationshipDataSets++;
			}

			// set data according to resourceIndex
			if (self.resourceData.data && self.resourceData.data[separator.resourceIndex]){
				data = { data: utils.simpleCopy(self.resourceData.data[separator.resourceIndex]) };
			}
			else {
				data = { data: { attributes: { }}};

				if(!isSingle && separatorKey !== undefined){
					data.data.attributes[self.config.separatorKey] = separatorKey;
				}
			}
			data.data.resource = utils.simpleCopy(separator.resource || {});

			let elementHeadOptions = {
				icon: separator.icon,
				title: separator.title
			}

			const actionExtension = {}
			if(utils.isFunction(self.updateRelationshipElement)){
				self.updateRelationshipElement(elementHeadOptions, data, separator.resourceIndex, actionExtension)
			}

			// perform relationshipElement add action(s)
			switch (self.config.separatorMode) {
				case 'tabStrip':
					return self.performAction(
						self.prepareAction(utils.simpleMerge({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.TAB,
							source: {
								tab: {
									componentData: {
										resourceData: elementHeadOptions
									}
								},
								tabContentContainer: {
									config: {
										separator: separator,
									}
								},
								tabContent: {
									componentData: {
										component: self.config.subFormComponent || self.config.defaultSubFormComponent,
										// children: utils.simpleCopy(self.postponedChildren || []),
										resourceData: data,
										config: {
											separator,
											separatorKey: separatorKey,
											subFormAlias: self.config.subFormAlias,
											relationshipDataIndex: separator.resourceIndex,
											submitAllResources: self.config.submitAllResources,
											resourceRegisterKey: self.config.resourceRegisterKey,
											componentDataDependentFieldAssociation: self.config.componentDataDependentFieldAssociation,
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + separator.resourceIndex
									}
								}
							},
							waitForActionID: 'relationContainer',
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content > .base_tabStrip_tabStrip'
							}
						}, actionExtension))
					);

				case 'accordion':
					return self.performAction(
						self.prepareAction(utils.simpleMerge({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.ACCORDION,
							source: {
								elementContainer: {
									componentData: {
										config: {
											separator: separator,
										},
										model: {
											headOptions: elementHeadOptions,
										},
									},
								},
								element: {
									componentData: {
										component: self.config.subFormComponent || self.config.defaultSubFormComponent,
										children: utils.simpleCopy(self.postponedChildren || []),
										resourceData: data,
										config: {
											separatorKey: separatorKey,
											subFormAlias: self.config.subFormAlias,
											relationshipDataIndex: separator.resourceIndex,
											submitAllResources: self.config.submitAllResources,
											resourceRegisterKey: self.config.resourceRegisterKey,
											componentDataDependentFieldAssociation: self.config.componentDataDependentFieldAssociation,
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + separator.resourceIndex
									}
								}
							},
							waitForActionID: 'relationContainer',
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content > .base_accordion_accordion'
							}
						}, actionExtension))
					)

				case 'component':
					return self.performAndStoreAction(
						undefined,
						self.prepareAction(utils.simpleMerge({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
							source: {
								load: {
									componentData: {
										component: self.config.separatorComponent,
										resourceData: data,
										children: utils.simpleCopy(self.postponedChildren || []),
										config: {
											separatorKey: separatorKey,
											separator: separator,
											subFormAlias: self.config.subFormAlias,
											relationshipDataIndex: separator.resourceIndex,
											isHorizontal: self.config.isHorizontal,
											preventAllFieldLabels: self.config.preventAllFieldLabels,
											submitAllResources: self.config.submitAllResources,
											resourceRegisterKey: self.config.resourceRegisterKey,
											componentDataDependentFieldAssociation: self.config.componentDataDependentFieldAssociation,
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + (separator.resourceIndex || self.config.subFormAlias || '~')
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
							}
						}, actionExtension))
					);

				case 'inline':
					return self.performAndStoreAction(
						undefined,
						self.prepareAction(utils.simpleMerge({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
							source: {
								load: {
									componentData: {
										component: self.config.subFormComponent || self.config.defaultSubFormComponent,
										resourceData: data,
										children: utils.simpleCopy(self.postponedChildren || []),
										config: {
											separatorKey: separatorKey,
											separator: separator,
											subFormAlias: self.config.subFormAlias,
											parentFormResourceKey: self.config.parentFormResourceKey,
											relationshipDataIndex: separator.resourceIndex,
											isHorizontal: self.config.isHorizontal,
											preventAllFieldLabels: self.config.preventAllFieldLabels && (!self.config.isHorizontal || self.model.nrOfRelationshipElements > 1),
											submitAllResources: self.config.submitAllResources,

											resourceRegisterKey: self.config.resourceRegisterKey,
											subFormAliasContainer: self.config.subFormAliasContainer,
											componentDataDependentFieldAssociation: self.config.componentDataDependentFieldAssociation,
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + (separator.resourceIndex || self.config.subFormAlias || '~')
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content',
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
							},
						}, actionExtension))
					);
			}
		},

		/**
		 * dynamic add of relationship element
		 *
		 * @returns {*}
		 */
		showInsert: function(){
			return this.addRelationshipElement();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			var relationshipSourceComponent = (additionalData || {}).sourceComponent;
			if(relationshipSourceComponent){
				var sourceComponentConfig = relationshipSourceComponent.config || {};
				if(sourceComponentConfig.relationshipDataIndex !== undefined){
					this.subFieldsToModel(sourceComponentConfig.subFormAlias, {}, true, sourceComponentConfig.relationshipDataIndex, sourceComponentConfig.parentFormResourceKey);
					var firstOneFound = false;
					// correct preventAllFieldLabels flag of first inline element if necessary
					this.find('base_form_form', undefined, function(form){
						if(form.componentIndex === relationshipSourceComponent.componentIndex){
							firstOneFound = true;
						} else if(firstOneFound){
							form.config.preventAllFieldLabels = false;
							form.refresh(false);
							return 'break';
						} else {
							return 'break';
						}
					});
					self.model.nrOfRelationshipElements--;
					relationshipSourceComponent.destroy();
					return utils.promise.resolve();
				}
			}
		},

		onBuild: function(){
			// if a jsonb field will be set in attributes according to the forms contents, only submitting dirty values would not cut it.
			if((this.config.availableSeparators || {}).type === 'single' && this.config.subFormAlias){
				this.config.submitAllResources = true
			}
		}
	},

	hooks: {
		include: function($element, options){
			if(!options.refresh){
				var containerComponentConfig = {};

				// TODO: REWORK THIS:
				//  		i don't remember why this should be reworked
				if(this.config.separatorMode === 'tabStrip'){
					containerComponentConfig.closableTabs = false;
				}

				if(this.config.relationContainerConfigExtension){
					containerComponentConfig = utils.simpleMerge(containerComponentConfig, this.config.relationContainerConfigExtension)
				}

				// add base container for this relationship if necessary
				if(this.config.modeDependentContainerComponent[this.config.separatorMode]){
					this.performAndStoreAction(
						'relationContainer',
						this.prepareAction({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
							source: {
								load: {
									componentData: {
										component: this.config.modeDependentContainerComponent[this.config.separatorMode],
										config: containerComponentConfig
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content',
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML
							}
						})
					)
				}
			}
		},

		attach: function($element, options){
			if(!options.refresh) {

				// prepare default actions
				this.prepareDefaultActions();

				// init
				var self = this;
				var performActions = [];

				// init availableSeparators if necessary
				if(!self.config.availableSeparators.initialized){
					self.config.availableSeparators.initialized = true;
					if(utils.isFunction(self.updateAvailableSeparators)){
						self.updateAvailableSeparators();
					}
					else if(utils.isCollection(self.config.availableSeparators) && self.config.availableSeparators.type != undefined){
						// take availableLangCodes from storage
						if(self.config.availableSeparators.type === 'availableLangCodes'){
							const availableLangCodes = utils.language.getConfig(storage).available
							if(utils.collectionSize(availableLangCodes) > 0){
								self.config.availableSeparators.list = utils.simpleCopy(availableLangCodes)
							}
						}
						// take available dataIndexes
						else if(self.config.availableSeparators.type === 'dataIndex'){
							self.config.availableSeparators.list = [];
							for(var dataIndex in self.resourceData.data || []){
								self.config.availableSeparators.list[dataIndex] = {};
							}
						}
						// take separators from model field
						else if(self.config.availableSeparators.type === 'field' && self.config.availableSeparators.fieldCode != undefined){
							var fieldProperties;
							var field;
							if((fieldProperties = self.getFieldProperties(self.config.availableSeparators.fieldCode)) != undefined){
								if(fieldProperties.modelFieldIndex && self.model.fields[fieldProperties.modelFieldIndex]){
									field = self.model.fields[fieldProperties.modelFieldIndex];
								}
							}

							if(field != undefined && field.atom != undefined){
								if((field.atom.dataType === 'category-picker' || field.atom.dataType === 'resource-picker' || field.atom.dataType === 'template-picker') && field[field.atom.dataType + '-data'] != undefined && field[field.atom.dataType + '-data'].options){
									self.config.availableSeparators.list = {};
									utils.forEach(field[field.atom.dataType + '-data'].options, function(separatorOption){
										self.config.availableSeparators.list[separatorOption.value] = {
											title: 		separatorOption.name,
											resource:  	separatorOption.resource || {}
										};
									});
								}
							}
						}
						// use relationship form as single element without separators. e.g., data.attributes.additionalData::jsonb should be set by this form elements.
						else if((self.config.availableSeparators || {}).type === 'single'){
							performActions.push(self.addRelationshipElement());
						}
					}
				}

				utils.forEach(self.config.availableSeparators.list, function (separator, separatorKey) {
					performActions.push(self.addRelationshipElement(separatorKey, separator));
				});

				// init right container state
				switch (self.config.separatorMode) {
					case 'tabStrip':
						utils.promise.performAll(self, performActions).then(function(context){
							self.find('base_tabStrip_tabStrip', function(tabStripComponent){
								tabStripComponent.focusTab(0);
							});
						});
						break;

					case 'accordion':
						utils.promise.performAll(self, performActions).then(function(context){
							self.find('base_accordion_accordion', function(tabStripComponent){
								tabStripComponent.focusElement(0);
							});
						});
						break;
				}
			}
		}
	}
};
